import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { TimeService } from '../time.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { CommonConfirmationComponent } from '../common-confirmation/common-confirmation.component';

@Component({
  selector: 'app-epod-preview',
  templateUrl: './epod-preview.component.html',
  styleUrls: ['./epod-preview.component.scss']
})
export class EpodPreviewComponent implements OnInit {

  totalWeight: any;
  showLoader: boolean;
  selectedDelivery: any;
  reject_reason: any;
  isRejecting: boolean;
  extension: any;
  filteredInvoiceList: any = [];
  showCloseButton = false;
  constructor(@Inject(MAT_DIALOG_DATA) private parentData: any, private timeService: TimeService, private popup: MatDialog, private snackbar: SnackbarService, private http: HttpService, private dialog: MatDialogRef<EpodPreviewComponent>) { }
  previewImage: any;
  receivedQty = 0;
  customerName = '';
  plantCode = '';
  doNumbers = '';
  invoiceNumber = '';
  lrNumber = '';
  epodUploadDate = '';
  deliveryCompletionDate = '';
  noOfPieces = 0;
  deliveriesList: any = [];
  isImage = false;
  isPdf = false;
  previewPdf: any = '';
  imageList: any = [];
  selectedInvoice: any = {};
  invoiceList: any = [];
  ngOnInit(): void {
    const { invoices } = this.parentData;
    this.showCloseButton = this.parentData.deleteEpod;
    this.invoiceList = invoices;
    this.filteredInvoiceList = this.invoiceList.slice();
    this.selectedInvoice = invoices[0];
    this.getDetails();
    
    
  }
  showPreview(image: string) {
    this.isImage = false;
    this.isPdf = false;
    this.extension = image.split('.');
    this.extension = this.extension[this.extension.length - 1];
    if (this.extension === 'pdf') {
      this.previewPdf = image;
      this.isPdf = true;
    } else {
      this.previewImage = image;
      this.isImage = true;
    }
    this.previewImage = image;
  }
  approve() {
    this.showLoader = true;
    this.http.post('v1/shipment/approveEpod', { delivery: this.selectedDelivery._id, approved: true }).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.showLoader = false;
          this.snackbar.openSnackBar('EPOD`s Approved Successfully', '', '');
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }
  disapprove() {
    this.isRejecting = true;
  }
  closeReasonBox() {
    this.isRejecting = false;
  }
  selectInvoice(event, inv) {
    if (event.source._selected) {
      this.selectedInvoice = inv;
      this.getDetails();
    }
  }
  openImagePopup() {
    document.getElementById("myPopup").style.display = "block";
  }

  closePopup() {
    document.getElementById("myPopup").style.display = "none";
  }
  submitReason() {

    if (this.reject_reason.length == 0) {
      return this.snackbar.openSnackBar('Please Give reason for rejection', '', 'err');
    }
    else {
      this.showLoader = true;
      this.http.post('v1/shipment/approveEpod', { delivery: this.selectedDelivery._id, approved: false, reason: this.reject_reason }).subscribe(
        (data: any) => {
          ;
          if (data.statusCode == 200) {
            this.showLoader = false;
            this.snackbar.openSnackBar('EPOD`s has been Rejected', '', '');
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar('Something went wrong', '', 'err');
        }
      );
      this.isRejecting = false;
    }
  }
  getDetails() {
    const { delivery_id, commercial_invoices } = this.selectedInvoice;
    
    this.selectedDelivery = delivery_id;

    this.imageList = commercial_invoices[0].others.epods;
    this.extension = this.imageList[0].split('.');
    this.extension = this.extension[this.extension.length - 1];
    if (this.extension === 'pdf') {
      this.previewPdf = this.imageList[0];
      this.isPdf = true;
    } else {
      this.previewImage = this.imageList[0];
      this.isImage = true;
    }
    this.customerName = this.selectedDelivery.location.name;
    this.plantCode = commercial_invoices[0].others.plant_code || 'N/A';
    this.doNumbers = commercial_invoices[0].others.do_number;
    this.invoiceNumber = commercial_invoices[0].num;

    this.lrNumber = commercial_invoices[0].others.LR_Number || 'N/A';
    this.deliveryCompletionDate = this.selectedDelivery.finished_at ? this.timeService.toShortDateTime24(this.selectedDelivery.finished_at) : 'N/A';
    this.epodUploadDate = this.selectedDelivery.epod_uploaded_date ? this.timeService.toShortDateTime24(this.selectedDelivery.epod_uploaded_date) : 'N/A';
    this.totalWeight = commercial_invoices[0].others.invoiceWeight;
    this.noOfPieces = commercial_invoices[0].nop;
    this.receivedQty = commercial_invoices[0].others.received_quantity;

  }
  applyFilter(filterValue: string) {
    if (!filterValue) {
      this.filteredInvoiceList = this.invoiceList.slice(); // Reset to full list
    } else {
      this.filteredInvoiceList = this.invoiceList.filter(inv =>
        inv.commercial_invoices[0].others.do_number.includes(filterValue)
      );
    }
  }
  deleteEpod() {
    const payload = {
      id: this.selectedDelivery._id,
      invoice: this.selectedInvoice._id,
      ...(this.isImage && { src: this.previewImage }),
      ...(this.isPdf && { src: this.previewPdf }),
    };
    const dialogRef = this.popup.open(CommonConfirmationComponent, {
      data: payload,
    });
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if(data)
        {
          this.dialog.close();
        }
      }
    )
  }
}
